import {InPageAlert} from '@snsw-gel/react';
import React from 'react';
import {EligibilityFailureScenario, SoleTraderFailure, TollAccountFailure} from '../../services/api-services';
import {PhoneElement} from '../../utils/elements';

interface ApiErrorAlertProps {
    readonly errorReason: EligibilityFailureScenario;
}

const ApiErrorAlert: React.FC<ApiErrorAlertProps> = ({errorReason}) => {
    const [title, description] = errorTitleAndDescription(errorReason);

    return <InPageAlert variant='error' title={title} role='alert'>
        {description}
    </InPageAlert>;
};

// TODO remove this file after Tr2 decom
function errorTitleAndDescription(errorReason: EligibilityFailureScenario): [string, React.JSX.Element] {
    let title: string;
    let description: React.JSX.Element;
    switch (errorReason) {
        case TollAccountFailure.tollAccountAlreadyLinked:
            title = 'Unable to link this toll account';
            description = <>
                <p>This toll account is already linked to another MyServiceNSW Account. Only one
                person can claim toll relief on this account at a time.</p>
                <p>If you need assistance, call us on {PhoneElement}.</p>
            </>;
            break;
        case TollAccountFailure.tollAccountProductTypeInvalid:
            title = 'We cannot link this toll account';
            description = <>
                <p>The toll account provided is associated with an invalid toll product. Casual toll products (such as LinktGO) or special passes (for example, the ERider and eMU passes) are not eligible for Toll Relief. Check the eligibility criteria.</p>
                <p>If you need help, {PhoneElement}.</p>
            </>;
            break;
        case SoleTraderFailure.abnAlreadyLinked:
            title = 'Unable to link this toll account';
            description = <>
                <p>Your ABN is already linked to another MyServiceNSW account.</p>
                <p>Only one ABN can be linked to a MyServiceNSW account.</p>
                <p>If you need assistance, call us on {PhoneElement}.</p>
            </>;
            break;
        case TollAccountFailure.customerHasTollAccountLinkedToAnotherMyAccountId:
            title = 'You have another MyServiceNSW Account with a linked toll account';
            description = <>
                <p>Only one personal, business or mixed (personal and business) toll account can be linked to
                an individual at a time.</p>
                <p>
                    You can either:
                    <ul>
                        <li>log into your other MyServiceNSW Account to view your toll spend, or</li>
                        <li>log into your other MyServiceNSW Account and unlink the toll account.
                        You can then continue linking this current MyServiceNSW Account.</li>
                    </ul>
                </p>
                <p>If you need assistance, call us on {PhoneElement}.</p>
            </>;
            break;
        case 'other':
            title = 'System error';
            description = <>We're experiencing an issue looking up your registration details. Try again later.</>;
            break;
        default:
            title = 'Unable to link this toll account';
            description = <></>;
            console.warn('Failed linking on review page. No design for given reason.', errorReason);
    }

    return [title, description];
}

export default ApiErrorAlert;
